import { FuseResult, RangeTuple } from 'fuse.js';
import { PAGE_SIZE } from './Search.constants';
import { TSearchItem } from './Search.types';

export const getSearchItemBreadCrumbs = (item: TSearchItem, query?: string | null) => {
  return query
    ? [
        { text: item.pageTitle.toLowerCase(), href: item.path },
        { text: item.sectionTitle?.toLowerCase(), href: `${item.path}#${item.id}` },
      ].filter((breadCrumb) => !!breadCrumb.text)
    : [];
};

export const getHighlightedMatchValue = (value: string, indices: readonly RangeTuple[]) => {
  return indices.reduceRight((result, [start, end]) => {
    return (
      result.substring(0, start) +
      '<mark>' +
      result.substring(start, end + 1) +
      '</mark>' +
      result.substring(end + 1)
    );
  }, value);
};

export const getSubtitleText = (count: number, currentPage: number, key: string) => {
  if (!count) return 'По вашему запросу ничего не найдено';

  const remainder = count % 10;
  const label = remainder === 1 ? 'результат' : remainder < 5 ? 'результата' : 'результатов';

  return `${currentPage * PAGE_SIZE + 1}-${Math.min((currentPage + 1) * PAGE_SIZE, count)} из ${count} ${label} по запросу: ${key}`;
};

export const getTotalCount = (results: FuseResult<TSearchItem>[]) =>
  results?.reduce((total, item) => total + (item.matches?.length || 0), 0) || 0;
